import React from 'react'
import { NavigationItem } from '@/components/atoms/NavigationItem'
import {
  LayoutDashboard,
  Megaphone,
  ContactRound,
  FileText,
  Bot,
  Hash,
  Inbox,
  Users2,
  TrendingUp,
  CreditCard,
  FolderOpen
} from '@/components/icons'

interface NavigationMenuProps {
  activeItem?: string
  onItemClick?: (item: string) => void
  isCollapsed?: boolean
}

const navigationItems = [
  { key: 'dashboard', icon: LayoutDashboard, label: 'Dashboard' },
  { key: 'campaigns', icon: Megaphone, label: 'Campaigns' },
  { key: 'contacts', icon: ContactRound, label: 'Contacts' },
  { key: 'templates', icon: FileText, label: 'Templates' },
  { key: 'agents', icon: Bot, label: 'Agents' },
  { key: 'channels', icon: Hash, label: 'Channels' },
  { key: 'library', icon: FolderOpen, label: 'Library' },
  { key: 'inbox', icon: Inbox, label: 'Inbox' },
  { key: 'teams', icon: Users2, label: 'Teams' },
  { key: 'analytics', icon: TrendingUp, label: 'Analytics' },
  { key: 'billing', icon: CreditCard, label: 'Billing' }
]

export const NavigationMenu: React.FC<NavigationMenuProps> = ({
  activeItem,
  onItemClick,
  isCollapsed = false
}) => {
  return (
    <div className="w-full space-y-1">
      {navigationItems.map((item) => (
        <NavigationItem
          key={item.key}
          icon={item.icon}
          label={item.label}
          isActive={activeItem === item.key}
          onClick={() => onItemClick?.(item.key)}
          isCollapsed={isCollapsed}
        />
      ))}
    </div>
  )
}